export default "/images/vendor/flag-icon-css/flags/1x1/ao.svg?7ed590a16ff7642e7a85cc845a56f4b8";